const LEVELS = {
  error: 0,
  warn: 1,
  info: 2,
  debug: 3
};

const configuredLevel = String(process.env.REACT_APP_LOG_LEVEL || 'warn').toLowerCase();
const activeLevel = Object.prototype.hasOwnProperty.call(LEVELS, configuredLevel)
  ? LEVELS[configuredLevel]
  : LEVELS.warn;

const original = {
  error: console.error.bind(console),
  warn: console.warn.bind(console),
  info: console.info.bind(console),
  log: console.log.bind(console),
  debug: console.debug.bind(console)
};

function mask(value) {
  if (typeof value === 'string') {
    return value
      .replace(/([A-Z0-9._%+-])[A-Z0-9._%+-]*(@[A-Z0-9.-]+\.[A-Z]{2,})/gi, '$1***$2')
      .replace(/(bearer\s+)[A-Z0-9._~-]+/gi, '$1[redacted]');
  }

  if (value instanceof Error) return { name: value.name, message: mask(value.message) };
  if (value && typeof value === 'object') return '[details omitted]';
  return value;
}

function write(level, args) {
  if (LEVELS[level] > activeLevel) return;
  const method = level === 'debug' ? original.log : original[level];
  method(`[${level.toUpperCase()}]`, ...args.map(mask));
}

console.error = (...args) => write('error', args);
console.warn = (...args) => write('warn', args);
console.info = (...args) => write('info', args);
console.log = (...args) => write('debug', args);
console.debug = (...args) => write('debug', args);
